module.exports = __webpack_public_path__ + "static/media/cruz.6ffb6eab.png";